<template>
  <div class="calendar-container" ref="calendarContainer">
    <div class="bg"></div>
    <div class="title" ref="calendarTitle" :class="[noMore ? 'no-more' : '']">
      <!-- <span class="text">游戏情报</span> -->
      <div class="left">
        <img class="img-text" src="@/assets/images/yxrl.png" alt="" />
        <div class="filter" @click="handleBury">
          <div class="type-filter">
            <div
              class="item"
              v-for="item in filterTypes"
              :key="item.value"
              :class="{ active: item.value === filter.type }"
              @click="handleFilterType(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
          <ElPopover v-model="gameNameSearchListVisible" trigger="manual" placement="bottom" width="200">
            <div slot="reference" class="game-search">
              <img class="icon" src="@/assets/images/search-icon-1.png" alt="" />
              <input
                v-model="gameFilterName"
                type="text"
                placeholder="请输入游戏名称"
                @input="handleFilterGameName"
                @keyup.enter="handleFilterGameName"
                @focus="gameNameSearchListVisible = true"
                @blur="gameNameSearchListVisible = false"
              />
            </div>
            <div class="game-popover-list">
              <template v-if="filterGameNameList.length">
                <div
                  class="item"
                  v-for="item in filterGameNameList"
                  :key="item"
                  :class="{ active: item == gameFilterName }"
                  @click="handleFilterName(item)"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else>
                <div class="empty">暂无数据</div>
              </template>
            </div>
          </ElPopover>
        </div>
      </div>
      <a class="more" href="/calendar" target="_blank" @click="handleBury">更多</a>
    </div>
    <div class="container">
      <div class="date-game-box">
        <!-- <Swiper
          class="nav-swiper"
          ref="swiperNav"
          :options="{ ...swiperNavOptions, initialSlide: activeSwiperIndex }"
          @slideChange="handleSwiperNavChange"
        >
          <SwiperSlide class="swiper-slide" >

          </SwiperSlide>
        </Swiper> -->
        <!-- <ElScrollbar class="scrollbar" ref="scrollbar"> -->
        <div class="scrollbar" ref="scrollbar">
          <template v-for="(item, index) in filterList">
            <div
              class="game-item"
              :key="filter.key + index"
              :class="{ active: activeSwiperIndex == index }"
              v-if="item.game"
              @click="handleSelect(index)"
            >
              <div class="date">
                <template v-if="item.date != '99-99'">
                  <template v-if="!filterList[index - 1] || item.date !== filterList[index - 1].date">
                    {{ item.date }}
                  </template>
                </template>
                <template v-else> 待定 </template>
              </div>
              <div class="icon">
                <img v-if="item.game.icon" :src="item.game.icon" alt="" />
                <img src="@/assets/images/calendar-wiki-icon-default.png" alt="" />
              </div>
              <div class="info">
                <div class="name" :title="item.game.name">{{ item.game.name }}</div>
                <div class="tag" v-show="item.data[0] && item.data[0].tag">{{ item.data[0] && item.data[0].tag }}</div>
              </div>
            </div>
          </template>
        </div>
        <!-- </ElScrollbar> -->
      </div>
      <div class="game-content-box">
        <Swiper
          class="content-swiper"
          ref="swiperContent"
          :options="{ ...swiperContentOptions, initialSlide: activeSwiperIndex }"
          @slideChange="handleSwiperContentChange"
        >
          <SwiperSlide
            class="swiper-slide parent-no-swiping"
            v-for="(item, index) in filterList"
            :key="filter.key + index"
          >
            <div class="content-container">
              <div class="game-content-item" @click="handleBury">
                <div class="top">
                  <template v-if="!isEmpty(item.data)">
                    <CalendarSwiper
                      :list="item.data"
                      :swiperIndex="index"
                      :isShow="index >= activeSwiperIndex - 2 && index <= activeSwiperIndex + 2"
                    />
                  </template>
                  <template v-else>
                    <div class="empty-box">
                      <img src="@/assets/images/calendar-empty.png" alt="" />
                    </div>
                  </template>
                </div>
                <div class="bottom" v-if="item.game">
                  <div class="icon">
                    <img v-if="item.game.cover" :src="item.game.cover" alt="" />
                    <img src="@/assets/images/calendar-wiki-cover-default.png" alt="" />
                  </div>
                  <div class="info">
                    <div class="name">{{ item.game.name }}</div>
                    <div class="desc" :title="removeHtmlTags(item.game.description)">
                      {{ removeHtmlTags(item.game.description) }}
                    </div>
                  </div>
                  <div class="go-btn">
                    <a class="go-wiki" :href="getJumpWikiUrl(item.game.alias, item.game.id, true)" target="_blank">
                      前往wiki <img src="@/assets/images/home-go-wiki-icon.png" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

import CalendarSwiper from "./CalendarSwiper.vue";
import { debounce, getJumpWikiDetailUrl, getJumpWikiUrl } from "@/plugins/util";

export default {
  name: "GameCalendar",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    noMore: {
      type: Boolean,
      default: false
    }
  },
  components: { Swiper, SwiperSlide, CalendarSwiper },
  data() {
    return {
      activeSwiperIndex: 0,
      swiperNavOptions: {
        direction: "vertical",
        threshold: 20,
        slidesPerView: 9,
        spaceBetween: 15,
        slideToClickedSlide: true,
        centeredSlides: true
      },
      swiperContentOptions: {
        noSwiping: true,
        noSwipingClass: "parent-no-swiping",
        direction: "vertical",
        threshold: 20,
        spaceBetween: 100,
        slidesPerView: 1,
        slideToClickedSlide: true,
        centeredSlides: true
      },
      filterTypes: [
        { label: "全部", value: "" },
        { label: "角色更新", value: 1 },
        { label: "活动更新", value: 2 },
        { label: "新游上线", value: 4 }
      ],
      filter: {
        key: 0,
        type: "",
        gameName: ""
      },
      gameFilterName: "",
      gameNameSearchListVisible: false,
      isFixed: false,
      fixedTimer: null
    };
  },
  computed: {
    filterList() {
      if (!this.filter.type && !this.filter.gameName) return this.list;
      const filterList = this.list.filter(item => {
        const hasTypeData = this.filter.type ? item.data.some(it => it.type == this.filter.type) : true;
        const hasGameName = this.filter.gameName ? item.game.name.indexOf(this.filter.gameName) > -1 : true;
        return hasTypeData && hasGameName;
      });
      return filterList;
    },
    gameNameList() {
      const listName = this.list.map(item => item.game.name);
      return Array.from(new Set(listName));
    },
    filterGameNameList() {
      if (!this.gameFilterName) return this.gameNameList;
      return this.gameNameList.filter(item => {
        return item.indexOf(this.gameFilterName) > -1;
      });
    }
  },
  watch: {
    filterList: {
      handler(val) {
        this.findCurrentDate();
      },
      immediate: true
    }
  },
  mounted() {
    document.addEventListener("wheel", this.onMouseWheel, { passive: false });
    this.$nextTick(() => {
      this.findCurrentDate();
    });
  },
  beforeDestroy() {
    document.removeEventListener("wheel", this.onMouseWheel, { passive: false });
  },
  methods: {
    dayjs,
    getJumpWikiUrl,
    getJumpWikiDetailUrl,
    handleBury() {
      if (window.staticFn) {
        console.log("点击", "click_new_game calendar");
        if (this.$route.name === "wwwNewHome") {
          window.staticFn.customEvent("click_new_game calendar");
        }
      }
    },
    removeHtmlTags(str = "") {
      return str.replace(/<[^>]*>/g, "");
    },
    handleFilterType(value) {
      this.filter.type = value;
      this.filter.key = Math.random();
    },
    handleFilterGameName(e) {
      this.gameFilterName = e.target.value;
      if (!e.target.value) {
        this.filter.gameName = "";
        this.filter.key = Math.random();
      }
    },
    handleFilterName(value) {
      if (value == this.gameFilterName) {
        this.filter.gameName = "";
        this.gameFilterName = "";
        this.filter.key = Math.random();
      } else {
        this.gameFilterName = value;
        this.filter.gameName = value;
        this.filter.key = Math.random();
      }
    },
    findCurrentDate() {
      const list = this.filterList;
      if (list.length) {
        // 找到今天
        const today = Number(
          dayjs()
            .startOf("day")
            .unix()
        );
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          const curTime = item.time_at;
          const prevTime = i > 0 ? list[i - 1].time_at : 0;
          const nextTime = i < list.length - 1 ? list[i + 1].time_at : 99999999999;

          if (curTime == today) {
            this.activeSwiperIndex = i;
            // console.log(this.activeSwiperIndex);
            if (this.$refs.swiperContent) {
              this.$nextTick(() => {
                this.$refs.swiperContent.$swiper.slideTo(this.activeSwiperIndex);
              });
            }
            if (this.$refs.scrollbar) {
              const moveY = this.activeSwiperIndex * 107;
              this.$refs.scrollbar.scrollTo(0, moveY);
            }
            break;
          } else if (today > prevTime && today < nextTime) {
            this.activeSwiperIndex = i - 1 > 0 ? i - 1 : 0;
            // console.log(this.activeSwiperIndex);
            if (this.$refs.swiperContent) {
              this.$nextTick(() => {
                this.$refs.swiperContent.$swiper.slideTo(this.activeSwiperIndex);
              });
            }
            if (this.$refs.scrollbar) {
              const moveY = this.activeSwiperIndex * 107;
              this.$refs.scrollbar.scrollTo(0, moveY);
            }
            break;
          }
        }
        // console.log(this.activeSwiperIndex);
      }
    },
    onMouseWheel(e) {
      // const swiperNavEl = this.$refs.swiperNav.$el;
      // // const swiperContentEl = this.$refs.swiperContent.$el;
      // const swiperNav = this.$refs.swiperNav.$swiper;

      const calendarTitleEl = this.$refs.calendarTitle;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const offsetViewTop = calendarTitleEl.offsetTop - scrollTop;
      // console.log(calendarTitleEl.offsetTop, scrollTop, offsetViewTop, this.isFixed, e.deltaY);
      // if (this.$refs.scrollbar) {
      //   this.$refs.scrollbar.style.overflowY = "hidden";
      // }
      // 固定到日历
      // 向下
      if (offsetViewTop < 400 && offsetViewTop > -220 && e.deltaY > 0) {
        if (this.isFixed) {
          e.preventDefault();
          e.stopPropagation();
          const _this = this;
          if (this.fixedTimer) clearTimeout(this.fixedTimer);
          this.fixedTimer = setTimeout(() => {
            _this.isFixed = false;
          }, 300);
        } else {
          this.isFixed = true;
          this.$nextTick(() => {
            document.documentElement.scrollTo({
              top: calendarTitleEl.offsetTop,
              left: 0,
              behavior: "smooth"
            });
          });
        }
      }
      // 向上
      else if (offsetViewTop <= 20 && offsetViewTop > -220 && e.deltaY < 0) {
        if (this.isFixed) {
          e.preventDefault();
          e.stopPropagation();
          const _this = this;
          if (this.fixedTimer) clearTimeout(this.fixedTimer);
          this.fixedTimer = setTimeout(() => {
            _this.isFixed = false;
          }, 300);
        } else {
          this.isFixed = true;
          this.$nextTick(() => {
            document.documentElement.scrollTo({
              top: calendarTitleEl.offsetTop,
              left: 0,
              behavior: "smooth"
            });
          });
        }
      } else {
        this.isFixed = false;
      }
    },
    handleWheelchange: debounce(function(e) {
      const swiperNav = this.$refs.swiperNav.$swiper;
      if (e.deltaY > 0) {
        swiperNav.slideNext();
      } else {
        swiperNav.slidePrev();
      }
    }, 100),
    handleSwiperNavChange() {
      this.activeSwiperIndex = this.$refs.swiperNav.$swiper.activeIndex;
      this.$refs.swiperContent.$swiper.slideTo(this.activeSwiperIndex);
    },
    handleSwiperContentChange() {
      this.activeSwiperIndex = this.$refs.swiperContent.$swiper.activeIndex;
      // this.$refs.swiperNav.$swiper.slideTo(this.activeSwiperIndex);
    },
    handleSelect(index) {
      this.activeSwiperIndex = index;
      this.$refs.swiperContent.$swiper.slideTo(this.activeSwiperIndex);
    },
    isEmpty(data) {
      const first = data[0];
      const live2d = first.live2d ? JSON.parse(first.live2d) : null;
      const hasLive2d = live2d && live2d.atlas && (live2d.skel || live2d.json);
      const hasBigVideo = first.big_video_format && first.big_video_format.src;
      const hasSmallVideo = first.small_video_format && first.small_video_format.src;
      // 没有素材
      return !(first.bg_image || first.image || hasLive2d || hasBigVideo || hasSmallVideo);
    }
  }
};
</script>

<style lang="less" scoped>
.game-popover-list {
  width: 100%;
  .empty {
    text-align: center;
    font-size: 14px;
  }
  .item {
    width: 100%;
    height: 36px;
    line-height: 36px;
    padding: 0 10px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    border-radius: 4px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &:hover {
      background-color: #f3f3f3;
    }
    &.active {
      background-color: #e4f7ff;
      color: #13bdff;
    }
  }
}
.calendar-container {
  width: 100%;
  height: 1010px;

  .bg {
    position: absolute;
    left: 0;
    width: 100%;
    height: 1010px;
    background: url("~@/assets/images/calendar-container-bg.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 0px 0px 0px 0px;
  }
  .title {
    padding-top: 77px;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    &.no-more {
      padding: 20px;
      .more {
        display: none;
      }
    }
    .text {
      font-family: CKTKingKong, CKTKingKong;
      font-weight: bold;
      font-size: 30px;
      color: #000000;
      text-shadow: 2px 2px 0px #13bdff;
    }
    .img-text {
      height: 28px;
    }
    .left {
      display: flex;
      align-items: center;
    }
    .filter {
      display: flex;
      margin-left: 38px;
      .type-filter {
        display: flex;
        align-items: center;
        gap: 21px;
        min-width: 218px;
        height: 38px;
        background: #ffffff;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 46px 46px 46px 46px;
        padding: 8px 21px 10px;
        margin-right: 30px;
        .item {
          position: relative;
          min-width: 28px;
          height: 20px;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          cursor: pointer;
          &:hover {
            color: #333333;
          }
          &.active {
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            &::after {
              content: "";
              position: absolute;
              bottom: -2px;
              left: 50%;
              transform: translateX(-50%);
              display: inline-block;
              width: 11px;
              height: 2px;
              background: #05b8fe;
              border-radius: 1px 1px 1px 1px;
            }
          }
        }
      }
      .game-search {
        position: relative;
        width: 184px;
        height: 38px;
        background: #ffffff;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 46px 46px 46px 46px;
        padding: 9px 31px;
        .icon {
          position: absolute;
          top: 13px;
          left: 13px;
          width: 13px;
          height: 13px;
        }
        input {
          border: none;
          outline: none;
          width: 100%;
          height: 100%;
          font-weight: 400;
          font-size: 14px;
          color: #333;
          &::placeholder {
            color: #999999;
          }
        }
        &::after {
          content: "";
          position: absolute;
          top: 16px;
          right: 16px;
          display: block;
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 4px solid transparent;
          border-top: 6px solid #05b8fe;
        }
      }
    }
    .more {
      width: 57px;
      height: 30px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #d7d7d7;
      font-weight: 400;
      font-size: 16px;
      color: #444444;
      text-align: center;
      line-height: 30px;
    }
  }

  .container {
    display: flex;
    width: 1485px;
    gap: 5px;
    transform: translateX(-30px);
    .date-game-box {
      margin-left: -12px;
      width: 340px;
      height: 845px;
    }
    .nav-swiper {
      width: 340px;
      height: 845px;
      display: flex;
      flex-direction: column;
      /deep/ .swiper-wrapper {
        display: flex;
        flex-direction: column;
        .swiper-slide {
          width: 340px;
          height: 82px;
          margin-bottom: 15px;
        }
      }
      /deep/ .swiper-slide-active {
        .game-item {
          background: url("~@/assets/images/calendar-game-nav-active.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .scrollbar {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .game-item {
      position: relative;
      display: flex;
      align-items: center;
      width: 340px;
      height: 82px;
      padding-left: 98px;
      padding-right: 34px;
      cursor: pointer;
      margin-bottom: 15px;
      &.active {
        background: url("~@/assets/images/calendar-game-nav-active.png") no-repeat;
        background-size: 100% 100%;
      }

      .date {
        position: absolute;
        left: 40px;
        top: 31px;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #333333;
        margin-right: 20px;
      }
      .icon {
        flex-shrink: 0;
        width: 50px;
        height: 50px;
        box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.25);
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #ffffff;
        margin-right: 14px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          background: #e3e3e3;
          transition: all 0.2s;
          &:hover {
            transform: scale(1.05);
          }
        }
      }
      .info {
        flex: 1;
        width: 140px;
      }
      .name {
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        margin-bottom: 5px;
      }
      .tag {
        width: 100%;
        height: 18px;
        font-weight: 400;
        font-size: 14px;
        color: #05b8fe;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    /deep/ .content-swiper > .swiper-wrapper {
      transform: translate3d(120%, 0, 0);
    }
    .content-swiper {
      width: 1140px;
      height: 845px;
      margin-top: -30px;
      padding: 50px 44px 18px;

      .content-container {
        width: 100%;
        height: 100%;
        border-radius: 20px;
        //
      }
      .game-content-item {
        position: relative;
        height: 100%;
        box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.06);
        border-radius: 20px;
        .top {
          width: 100%;
          height: calc(100% - 131px);
          background: linear-gradient(180deg, #f5ffff 0%, #fbfff8 100%);
          border-radius: 20px;
          .empty-box {
            text-align: center;
            padding-top: 156px;
            img {
              width: 564px;
              height: 311px;
            }
          }
        }
        .bottom {
          position: absolute;
          bottom: 0;
          left: 0;
          display: flex;
          align-items: center;
          width: 100%;
          height: 131px;
          background: linear-gradient(180deg, #f3fffa 0%, #f4fdff 100%);
          border-radius: 0px 0px 20px 20px;
          padding: 17px 38px 19px;
          .icon {
            flex-shrink: 0;
            width: 73px;
            height: 95px;
            border-radius: 5px 5px 5px 5px;
            margin-right: 20px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }

          .info {
            flex: 1;
            height: 100%;
            .name {
              font-weight: 500;
              font-size: 16px;
              color: #333333;
              padding-top: 8px;
              margin-bottom: 18px;
            }
            .desc {
              display: block;
              width: 100%;
              height: 40px;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #666666;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .go-btn {
            width: 206px;
            padding: 50px 0 0 56px;
            .go-wiki {
              width: 105px;
              height: 35px;
              background: #bdf1ff;
              border-radius: 20px 20px 20px 20px;
              border: 1px solid #90e1ff;
              font-weight: 400;
              font-size: 15px;
              color: #006d98;
              padding: 7px 14px 7px 16px;
              img {
                width: 11px;
                height: 11px;
                vertical-align: middle;
                margin-right: 7px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
